{
  "newAnnouncement": "Tiene un nuevo anuncio",
  "notification": "Notificaciones y anuncios",
  "unread": "notificaciones no leídas"
}
